/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

import { Box, CircularProgress } from '@mui/material';

export const LoadingPage = () => (
    <Box display={'flex'} width={'100%'} height={'100%'} alignItems={'center'} justifyContent={'center'}>
        <CircularProgress color={'info'} size={30} />
    </Box>
);
